<template>
  <v-dialog :value="isOpen" :max-width="500">
    <v-card class="pa-4">
      <div class="dialog-header mb-2" v-if="header">
        <h2 class="dialog-content__title">
          {{ header }}
        </h2>
      </div>
      <v-card-text
        :class="{ 'pt-0 pb-0 mb-0': condensed, 'mb-2 pb-0': !condensed }"
      >
        <div
          class="dialog-content"
          :class="{ 'dialog-content--condensed': condensed }"
        >
          <paragraph>{{ text }}</paragraph>
        </div>
      </v-card-text>
      <v-card-actions>
        <div class="dialog-actions">
          <ui-button
            color="primary"
            class="flex-grow-1 mx-1"
            outlined
            @click="handleClose"
          >
            {{ $t(cancelLabelKey) }}
          </ui-button>
          <ui-button
            color="primary"
            class="flex-grow-1 flex-shrink-0 mx-1"
            @click="handleSave"
          >
            {{ $t(okLabelKey) }}
          </ui-button>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Paragraph from "./Paragraph";
export default {
  name: "ConfirmDialog",
  components: { Paragraph },
  props: {
    text: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    condensed: {
      type: Boolean,
      default: false
    },
    cancelLabelKey: {
      type: String,
      default: "message.common.cancel"
    },
    okLabelKey: {
      type: String,
      default: "message.common.save"
    }
  },
  data() {
    return {
      isOpen: true
    };
  },
  methods: {
    handleClose() {
      this.$emit("confirmed", false);
      this.closeDialog();
    },

    handleSave() {
      this.$emit("confirmed", true);
      this.closeDialog();
    },

    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-actions {
  display: flex;
  position: relative;
  bottom: 0;
  padding: 0 $spacing * 6;
  z-index: 1;
  width: 100%;
  justify-content: space-around;
}
.dialog-header {
  position: relative;
  top: 0;
  padding: 0 $spacing * 2;
  z-index: 1;
}

.dialog-content {
  position: relative;
  min-height: 100px;
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: $spacing * 2;
  padding-bottom: $spacing * 1.25;

  &--condensed {
    padding-top: 0;
    padding-bottom: 0;
  }

  > p {
    margin-bottom: 0;
  }
}
</style>
